<template>
  <ValidationProvider
    ref="observer"
    :rules="{ required: true }"
    :name="$t('forms.labels.type')"
  >
    <VSelect
      v-model="type"
      :label="$t('forms.labels.type')"
      :loading="loading"
      :items="displayedReportTypes"
      required
      :error="hasNotType"
      itemValue="id"
      itemText="name"
      :messages="hasNotType ? $t('forms.labels.reportTypeError') : ''"
      @input="updateData"
    />
  </ValidationProvider>
</template>

<script>
import { mapGetters } from 'vuex';
import { ValidationProvider } from 'vee-validate';

export default {
    components: {
        ValidationProvider,
    },
    props: {
        model: {
            type: String,
            default: '',
        },
        hasNotType: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            type: null,
            reportTypes: [],
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'lang',
        ]),
        displayedReportTypes() {
            return this.reportTypes.map(reportType => ({
                id: reportType.id,
                name: reportType.label ? reportType.label[this.lang] : '',
            }));
        },
    },
    async created() {
        this.loading = true;
        await this.getReportTypes();
        this.loading = false;
    },
    methods: {
        async getReportTypes() {
            this.loading = true;
            const { data } = await this.$rq.getReportTypes();
            this.reportTypes = data;
            this.loading = false;
        },
        updateData(select) {
            this.$emit('sendData', {
                selectedReportType: select,
            });
            if (select) {
                this.$emit('disabled', false);
            }
        },
    },
};
</script>
